import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ColumnChooserService, FilterService, SortService, PageService, ResizeService  } from '@syncfusion/ej2-angular-grids';
import { AgencyService } from './agency.service';
import { AgencyComponent } from './agency.component';
import { GetHTTPServiceAgency } from './agencylistData.service';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns'; 
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs'
import { NgSelectModule } from '@ng-select/ng-select';
import { AgencyRoutingModule } from './agency-routing.module';
import { CommonHttpService } from 'src/app/common.service';
import { CompanyListComponent } from './company-list/company-list/company-list.component';
import { GetHTTPServiceCompany } from './company-list-data.service';
import { UsNumberFormatPipe } from 'src/app/us-number-format.pipe';
import { SftpModule } from '../sftp/sftp.module';

// import { UsNumberFormatPipe } from 'src/app/us-number-format.pipe';

@NgModule({
  declarations: [
    AgencyComponent,
    CompanyListComponent,
    UsNumberFormatPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    NgSelectModule,
    DropDownListAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule ,
    AgencyRoutingModule,
    SftpModule
  ],
  schemas:[NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA],
  providers: [AgencyService,ColumnChooserService,GetHTTPServiceAgency,
    PageService,SortService,FilterService,ResizeService,DatePipe,GetHTTPServiceCompany
    ,CommonHttpService],
})
export class AgencyModule { }
